import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  iconColumn: {
    width: pxToRem(20),
    fontSize: pxToRem(16),
    textAlign: 'center',
    paddingTop: '0.1rem',
  },
  actionColumn: {
    color: theme.palette.accentMessage,
    fontSize: pxToRem(16),
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
        width: pxToRem(20),
        textAlign: 'center',
        fontSize: pxToRem(16),
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-40%)',
        verticalAlign: 'middle',
      },
    },
  },
  infoIcon: {
    position: 'relative',
    fontSize: pxToRem(16),
    marginLeft: pxToRem(5),
    marginTop: pxToRem(2),
    float: 'right',
    color: theme.palette.themePrimary,
  },
  listName: {
    width: pxToRem(280),
    fontSize: pxToRem(14),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingRight: pxToRem(20),
  },
  createdBy: {
    width: pxToRem(188),
    fontSize: pxToRem(14),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingRight: pxToRem(20),
  },
  chevronRight: {
    paddingLeft: pxToRem(7),
  },
  actionIndicatorIcon: {
    fontSize: pxToRem(24),
    color: theme.palette.red,
  },
  actionIndicator: {
    height: pxToRem(20),
    textAlign: 'center',
    color: theme.palette.red,
    paddingTop: '0.1rem',
    selectors: {
      '& .ms-Icon': {
        fontSize: pxToRem(24),
        position: 'absolute',
      },
    },
  },
});
